<template>
  <div>
    <div>
      <el-button
        type="text"
        v-for="item in countryList"
        :key="item.code"
        @click="btnDeleteCity(item)"
        :disabled="disabled"
      >
        {{ item.name }}<i class="el-icon-delete"></i>
      </el-button>
      <el-button
        type="primary"
        @click="dialogVisible = true"
        :disabled="disabled"
      >
        添加
      </el-button>
    </div>
    <div style="display: none">
      <!-- 目的城市子组件 returnParentValue：给子组件赋值   returnParentValue：子组件返回值（调用方法接收）-->
    </div>
    <el-dialog title="提示" v-model="dialogVisible" width="30%">
      <destination
        :returnParentValue="cityName"
        :parentCityCode="cityCode"
        @returnCityInfo="setDestination"
        :isHotCity="false"
      ></destination>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="btnAddCity()">确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import Destination from "../components/Destination.vue";

export default {
  name: "SelectCity",
  components: {
    Destination,
  },
  props: {
    setValue: {
      type: Array,
      default: () => {
        return [];
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    country: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      countryList: [],
      countrycode: "",
      cityName: "", //目的城市
      cityCode: "", //目的城市Code
      dialogVisible: false,
    };
  },
  methods: {
    // 子组件赋值目的城市 destination组件
    setDestination(value) {
      if (value.cityCode != "") {
        this.cityCode = value.cityCode;
        this.cityName =
          value.cityName + "-" + value.cityInfo.countryNameLists["zh-CN"];
        this.countrycode = value.cityInfo.countryCode;
      }
    },
    //删除
    btnDeleteCity(value) {
      this.countryList = this.countryList.filter(function (item) {
        return item.code != value.code;
      });
      this.$emit("func", this.countryList);
    },
    //添加
    btnAddCity() {
      //判断是否重复选中
      if (this.countryList.some((p) => p.code === this.cityCode)) {
        this.$alert("该城市已被选中，请重新选择", "提示", {
          confirmButtonText: "确定",
        });
      } 
      else if(this.country!="" && this.country.split(',').indexOf(this.countrycode)>=0)
      {
        this.$alert("该城市所在国家已在屏蔽中，请重新选中", "提示", {
          confirmButtonText: "确定",
        });
      }
      else {
        if (this.cityName != "" && this.cityCode != "") {
          let model = { name: this.cityName, code: this.cityCode };
          this.countryList.push(model);
        }
        this.dialogVisible = false;
        this.$emit("func", this.countryList);
      }
    },
  },
  mounted() {
    this.countryList = this.setValue;
  },
};
</script>

<style scoped>
</style>